(function () {
  'use strict';

  var COST_PER_SEC = { '1080p': 0.04, '1440p': 0.08, '2160p': 0.16 };
  var MARKUP = 1.2;
  var MAX_FILE_SIZE = 10 * 1024 * 1024;
  var ALLOWED_TYPES = ['image/jpeg', 'image/png', 'image/webp'];

  var selectedFile = null;
  var uploadedImageUrl = null;
  var endSelectedFile = null;
  var endUploadedImageUrl = null;

  function init() {
    if (typeof jQuery === 'undefined') {
      setTimeout(init, 100);
      return;
    }
    jQuery(document).ready(function () {
      setupImageUpload();
      setupEndImageUpload();
      setupGenerate();
      updateCost();
    });
  }

  function setupImageUpload() {
    jQuery('#reference-image-input').on('change', function (e) {
      if (e.target.files[0]) handleFileSelection(e.target.files[0], 'start');
    });
    var dropZone = jQuery('#image-drop-zone');
    dropZone.on('click', function (e) {
      if (e.target.id === 'reference-image-input') return;
      if (!selectedFile) jQuery('#reference-image-input').trigger('click');
    });
    dropZone.on('dragover', function (e) {
      e.preventDefault();
      e.stopPropagation();
      jQuery(this).addClass('drag-over');
    });
    dropZone.on('dragleave', function (e) {
      e.preventDefault();
      e.stopPropagation();
      jQuery(this).removeClass('drag-over');
    });
    dropZone.on('drop', function (e) {
      e.preventDefault();
      e.stopPropagation();
      jQuery(this).removeClass('drag-over');
      if (e.originalEvent.dataTransfer.files.length > 0)
        handleFileSelection(e.originalEvent.dataTransfer.files[0], 'start');
    });
    jQuery('#remove-image').on('click', function (e) {
      e.stopPropagation();
      removeImage('start');
    });
    document.addEventListener('paste', function (event) {
      if (!event.clipboardData || !event.clipboardData.items) return;
      var items = Array.from(event.clipboardData.items);
      var imageItem = items.find(function (item) {
        return item.type && item.type.startsWith('image/');
      });
      if (imageItem) {
        var blob = imageItem.getAsFile();
        if (blob) handleFileSelection(blob, 'start');
      }
    });
  }

  function setupEndImageUpload() {
    jQuery('#end-image-input').on('change', function (e) {
      if (e.target.files[0]) handleFileSelection(e.target.files[0], 'end');
    });
    var dropZone = jQuery('#end-image-drop-zone');
    dropZone.on('click', function (e) {
      if (e.target.id === 'end-image-input') return;
      if (!endSelectedFile) jQuery('#end-image-input').trigger('click');
    });
    dropZone.on('dragover', function (e) {
      e.preventDefault();
      e.stopPropagation();
      jQuery(this).addClass('drag-over');
    });
    dropZone.on('dragleave', function (e) {
      e.preventDefault();
      e.stopPropagation();
      jQuery(this).removeClass('drag-over');
    });
    dropZone.on('drop', function (e) {
      e.preventDefault();
      e.stopPropagation();
      jQuery(this).removeClass('drag-over');
      if (e.originalEvent.dataTransfer.files.length > 0)
        handleFileSelection(e.originalEvent.dataTransfer.files[0], 'end');
    });
    jQuery('#remove-end-image').on('click', function (e) {
      e.stopPropagation();
      removeImage('end');
    });
  }

  function handleFileSelection(file, which) {
    if (!ALLOWED_TYPES.includes(file.type)) {
      showNotification('Unsupported file type', 'error');
      return;
    }
    if (file.size > MAX_FILE_SIZE) {
      showNotification('File too large (max 10MB)', 'error');
      return;
    }
    if (which === 'end') {
      endSelectedFile = file;
      endUploadedImageUrl = null;
      jQuery('#end-image-name').text(file.name);
      document.getElementById('end-preview-img').src =
        URL.createObjectURL(file);
      jQuery('#end-upload-placeholder').hide();
      jQuery('#end-image-preview').show();
      jQuery('#end-image-drop-zone').addClass('has-image');
    } else {
      selectedFile = file;
      uploadedImageUrl = null;
      jQuery('#image-name').text(file.name);
      document.getElementById('preview-img').src = URL.createObjectURL(file);
      jQuery('#upload-placeholder').hide();
      jQuery('#image-preview').show();
      jQuery('#image-drop-zone').addClass('has-image');
    }
  }

  function removeImage(which) {
    if (which === 'end') {
      endSelectedFile = null;
      endUploadedImageUrl = null;
      jQuery('#end-image-input').val('');
      jQuery('#end-image-preview').hide();
      jQuery('#end-upload-placeholder').show();
      jQuery('#end-image-drop-zone').removeClass('has-image');
    } else {
      selectedFile = null;
      uploadedImageUrl = null;
      jQuery('#reference-image-input').val('');
      jQuery('#image-preview').hide();
      jQuery('#upload-placeholder').show();
      jQuery('#image-drop-zone').removeClass('has-image');
    }
  }

  function compressImageToWebP(file, quality) {
    return new Promise(function (resolve, reject) {
      var img = new Image();
      img.onload = function () {
        var canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;
        canvas.getContext('2d').drawImage(img, 0, 0);
        canvas.toBlob(
          function (blob) {
            if (!blob) return reject(new Error('compress failed'));
            var safeName = (file.name || 'image.png').replace(
              /\.[^/.]+$/,
              '.webp'
            );
            try {
              resolve(new File([blob], safeName, { type: 'image/webp' }));
            } catch (e) {
              resolve(blob);
            }
          },
          'image/webp',
          quality
        );
      };
      img.onerror = function () {
        reject(new Error('image load failed'));
      };
      img.src = URL.createObjectURL(file);
    });
  }

  function removeSpecialUrlChars(name) {
    return name.replace(/[,!#$%^&*(){}[\]<>;'?=":]/g, '').replace(/\s+/g, '-');
  }

  function fetchWithTimeout(resource, options, timeoutMs) {
    var controller = new AbortController();
    var id = setTimeout(function () {
      controller.abort();
    }, timeoutMs);
    return fetch(
      resource,
      Object.assign({}, options, { signal: controller.signal })
    ).finally(function () {
      clearTimeout(id);
    });
  }

  async function uploadImageFile(file, prefix) {
    showNotification('Compressing ' + prefix + ' image...', 'info');
    var compressed = await compressImageToWebP(file, 0.85);
    showNotification('Uploading ' + prefix + ' image...', 'info');
    var fileName = removeSpecialUrlChars(
      compressed.name || prefix + '-' + Date.now() + '.webp'
    );
    var signedResp = await fetchWithTimeout(
      '/file-upload-get-signed-url-cloudflare?' +
        new URLSearchParams({ file_type: 'image/webp', file_name: fileName }),
      { method: 'GET', headers: { 'Content-Type': 'application/json' } },
      10000
    );
    if (!signedResp.ok) throw new Error('Signed URL error');
    var signedUrl = await signedResp.json();
    return new Promise(function (resolve, reject) {
      var xhr = new XMLHttpRequest();
      xhr.open('PUT', signedUrl.url, true);
      xhr.timeout = 20000;
      xhr.onload = function () {
        if (xhr.status === 200) {
          var bucket = signedUrl.bucket_name || 'netwrckstatic.netwrck.com';
          resolve('https://' + bucket + '/' + signedUrl.object_path);
        } else reject(new Error('Upload failed'));
      };
      xhr.onerror = function () {
        reject(new Error('Upload failed'));
      };
      xhr.setRequestHeader('Content-Type', 'image/webp');
      xhr.send(compressed);
    });
  }

  function setupGenerate() {
    jQuery('#ltx23i2v-generate').on('click', generateVideo);
    jQuery('#ltx23i2v-duration, #ltx23i2v-resolution').on('change', updateCost);
  }

  function updateCost() {
    var duration = parseFloat(jQuery('#ltx23i2v-duration').val()) || 6;
    var resolution = jQuery('#ltx23i2v-resolution').val() || '1080p';
    var base = COST_PER_SEC[resolution] || 0.04;
    jQuery('#ltx23i2v-cost').text('$' + (base * duration * MARKUP).toFixed(2));
  }

  function getAuthSecret() {
    var creds =
      typeof window.getAuthCredentials === 'function'
        ? window.getAuthCredentials()
        : null;
    if (creds && creds.secret) return creds.secret;
    if (window.userData && window.userData.secret)
      return window.userData.secret;
    return '';
  }

  function showNotification(message, type) {
    if (
      window.NetwrckTools &&
      typeof window.NetwrckTools.showNotification === 'function'
    ) {
      window.NetwrckTools.showNotification(message, type || 'info');
      return;
    }
    if (typeof window.showSnackbar === 'function') {
      window.showSnackbar(message);
      return;
    }
    if (type === 'error') alert(message);
  }

  function appendLog(text) {
    var logs = jQuery('#generation-logs');
    logs.append('<div>' + text + '</div>');
    logs.scrollTop(logs[0].scrollHeight);
  }

  async function generateVideo() {
    var prompt = jQuery('#ltx23i2v-prompt').val().trim();
    if (!prompt) {
      showNotification('Enter a prompt', 'error');
      return;
    }

    var duration = parseFloat(jQuery('#ltx23i2v-duration').val()) || 6;
    var resolution = jQuery('#ltx23i2v-resolution').val() || '1080p';
    var base = COST_PER_SEC[resolution] || 0.04;
    var cost = base * duration * MARKUP;
    var credits = Math.ceil(cost * 100);

    var secret = getAuthSecret();
    if (!secret) {
      if (window.NetwrckTools) window.NetwrckTools.requireLogin();
      if (window.showSubscribeDialog) window.showSubscribeDialog();
      return;
    }
    if (
      window.NetwrckTools &&
      !window.NetwrckTools.checkCredits(credits, cost.toFixed(2))
    )
      return;

    var imageUrl = uploadedImageUrl;
    if (!imageUrl && selectedFile) {
      try {
        imageUrl = await uploadImageFile(selectedFile, 'start');
        uploadedImageUrl = imageUrl;
      } catch (err) {
        showNotification('Image upload failed: ' + err.message, 'error');
        return;
      }
    }
    if (!imageUrl) {
      showNotification('Upload a start image first', 'error');
      return;
    }

    var endImageUrl = endUploadedImageUrl;
    if (!endImageUrl && endSelectedFile) {
      try {
        endImageUrl = await uploadImageFile(endSelectedFile, 'end');
        endUploadedImageUrl = endImageUrl;
      } catch (err) {
        showNotification('End image upload failed: ' + err.message, 'error');
        return;
      }
    }

    jQuery('#ltx23i2v-loading').show();
    jQuery('#generation-logs').empty().show();
    appendLog('Submitting request...');

    var payload = {
      api_key: secret,
      prompt: prompt,
      image_url: imageUrl,
      duration: duration,
      resolution: resolution,
      aspect_ratio: jQuery('#ltx23i2v-aspect').val() || 'auto',
      fps: parseInt(jQuery('#ltx23i2v-fps').val(), 10) || 25,
      generate_audio: jQuery('#ltx23i2v-audio').is(':checked'),
      response_mode: 'polling',
    };
    if (endImageUrl) payload.end_image_url = endImageUrl;

    try {
      var response = await fetch('/api/ltx-2.3-image-to-video', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-API-Key': secret,
          Authorization: 'Bearer ' + secret,
        },
        body: JSON.stringify(payload),
      });
      var data = await response.json();
      if (!response.ok) {
        appendLog('Error: ' + (data.error || 'Request failed'));
        jQuery('#ltx23i2v-loading').hide();
        return;
      }
      if (response.status === 202 && data.job_id) {
        appendLog('Job queued: ' + data.job_id);
        pollJob(data.job_id, secret);
        return;
      }
      var url =
        (data.result && data.result.video && data.result.video.url) ||
        (data.video && data.video.url) ||
        data.video_url;
      if (url) {
        showVideo(url);
        appendLog('Generation complete');
      } else {
        appendLog('No video in response');
      }
      jQuery('#ltx23i2v-loading').hide();
    } catch (err) {
      appendLog('Error: ' + err.message);
      jQuery('#ltx23i2v-loading').hide();
    }
  }

  function pollJob(jobId, secret) {
    fetch('/api/fal/status/' + jobId + '?api_key=' + encodeURIComponent(secret))
      .then(function (resp) {
        return resp.json();
      })
      .then(function (data) {
        if (data.status === 'completed') {
          var url =
            (data.result && data.result.video && data.result.video.url) ||
            (data.result &&
              data.result.result &&
              data.result.result.video &&
              data.result.result.video.url);
          if (url) {
            showVideo(url);
            appendLog('Generation complete');
          } else {
            appendLog('No video in result');
          }
          jQuery('#ltx23i2v-loading').hide();
          return;
        }
        if (data.status === 'failed') {
          appendLog('Generation failed');
          jQuery('#ltx23i2v-loading').hide();
          return;
        }
        appendLog('Working...');
        setTimeout(function () {
          pollJob(jobId, secret);
        }, 4000);
      })
      .catch(function () {
        setTimeout(function () {
          pollJob(jobId, secret);
        }, 6000);
      });
  }

  function showVideo(videoUrl) {
    var html =
      '<div class="ai-video-item mdl-cell mdl-cell--stretch mdl-cell--12-col mdl-list__item">' +
      '<video controls autoplay loop style="max-width: 100%;"><source src="' +
      videoUrl +
      '" type="video/mp4"></video>' +
      '<div style="margin-top: 8px;"><a href="' +
      videoUrl +
      '" target="_blank" download style="color: #0f766e;">Download Video</a></div></div>';
    jQuery('#createdVideoList').prepend(html);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
